export const RESET = 'EXCMRELATION_LIST_RESET'
export const SET_ITEMS = 'EXCMRELATION_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMRELATION_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMRELATION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMRELATION_LIST_TOGGLE_LOADING'
